export function as_text(value, fallback = '') {
  const normalized = String(value === undefined || value === null ? '' : value).trim();
  return normalized || fallback;
}

export function parse_response_payload(payload) {
  if (typeof payload !== 'string') return payload || {};
  const trimmed = payload.trim();
  if (!trimmed) return {};
  return parse_json_payload(trimmed);
}

function parse_json_payload(payload) {
  try { return JSON.parse(payload); } catch { return {}; }
}

export function is_positive_id(id) {
  return Number.isFinite(id) && id > 0;
}

export function get_form_type_name_from(form) {
  return as_text(form?.form_type_name || form?.form_type?.form_type || form?.form_type);
}

export function to_positive_id(value) {
  const id = Number(value || 0);
  if (is_positive_id(id)) return id;
  return null;
}

export function is_document_type_name(name) {
  const normalized = as_text(name).toLowerCase();
  return normalized.includes('document');
}

export function get_response_items(payload) {
  const parsed = parse_response_payload(payload);
  if (Array.isArray(parsed?.data)) return parsed.data;
  return Array.isArray(parsed) ? parsed : [];
}

export function unique_positive_ids(ids) {
  const values = Array.isArray(ids) ? ids : [];
  return Array.from(new Set(values.map((id) => Number(id)).filter(is_positive_id)));
}
